import React, {Component} from 'react';
import PropTypes from 'prop-types';
import matchMedia from 'matchmediaquery';

export class LegalModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let width = '60%';
        let height = '75%';

        if (matchMedia('(max-width: 1030px)').matches) {
            // tablet/medium screen
            width = '80%';
        }
        if (matchMedia('(max-width: 720px)').matches) {
            // phone/small screen
            width = '100%';
            height = '100%';
        }
        

        return (<div style={styles.container}>
            <div style={{...styles.innerContainer, width, height}}>
                <div style={styles.closeContainer} onClick={()=>{this.props.close();}}>
                    <svg style={styles.closeButton} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12.7 12.7" enableBackground="new 0 0 12.7 12.7" xmlSpace="preserve">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.3,11.2c-0.3,0.3-0.3,0.9,0,1.2l0,0c0.3,0.3,0.9,0.3,1.2,0l11-11
                            c0.3-0.3,0.3-0.9,0-1.2l0,0c-0.3-0.3-0.9-0.3-1.2,0L0.3,11.2L0.3,11.2z M0.3,11.2"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.5,11.2c0.3,0.3,0.3,0.9,0,1.2l0,0c-0.3,0.3-0.9,0.3-1.2,0l-11-11
                            c-0.3-0.3-0.3-0.9,0-1.2l0,0c0.3-0.3,0.9-0.3,1.2,0L12.5,11.2L12.5,11.2z M12.5,11.2"/>
                    </svg>
                </div>
                <iframe style={styles.iframe} src={this.props.sourceUrl} />
            </div>
        </div>);
    }
}

const styles = {
    container: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: 100,
        backgroundColor: 'rgb(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    innerContainer: {
        backgroundColor: '#FFFFFF',
        width: '60%',
        height: '75%',
        padding: 8
    },
    closeButton: {
        stroke: '#000000',
        fill: '#000000',
        width: 12
    },
    closeContainer: {
        float: 'right',
        width: 12,
        height: 12,
        cursor: 'pointer'
    },
    iframe: {
        width: '100%',
        marginTop: 10,
        border: 'none',
        height: '93%'
    }
};